import { Link } from 'react-router-dom'
import '../styles/footer.css'

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="site-footer">
      <div className="container footer-container">
        {/* Верхняя строка: Логотип, быстрые кнопки и Наверх */}
        <div className="footer-top-row">
          <Link to="/" className="footer-brand" onClick={scrollToTop} title="CaseMania">
            <span className="footer-logo-glow" />
            <img src="/cmlogo.png" alt="CaseMania" className="footer-logo-img" />
          </Link>

          <div className="footer-actions">
            <a
              href="https://t.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-action-pill footer-pill-tg"
            >
              <svg className="footer-pill-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
              </svg>
              <span>Сообщество Telegram</span>
            </a>

            <a
              href="mailto:support@casemania.win"
              className="footer-action-pill"
            >
              <svg className="footer-pill-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              <span>Поддержка</span>
            </a>

            <button
              type="button"
              className="footer-scroll-top-btn"
              onClick={scrollToTop}
              title="Вернуться наверх страницы"
            >
              <span>Наверх</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="m18 15-6-6-6 6" />
              </svg>
            </button>
          </div>
        </div>

        {/* Описание и реквизиты */}
        <div className="footer-info">
          <p className="footer-desc">
            CaseMania — премиальная платформа с кейсами CS2, системой апгрейдов и крафтами. Пользователи могут открывать кейсы, улучшать скины и создавать контракты обмена в сервисе CaseMania с моментальным получением предметов.
          </p>

          <p className="footer-requisites">
            ОсОО «Транстрейд» (ОГРН: 310961-3301-ООО, ИНН: 9909710251). Адрес компании: Кыргызская республика, Бишкек, Ленинский район, ул Калык Акиева 66
          </p>
        </div>

        <div className="footer-divider" aria-hidden="true" />

        {/* Нижняя строка: копирайт, 18+ и юридические ссылки */}
        <div className="footer-bottom-bar">
          <div className="footer-copy-wrap">
            <span className="footer-badge-18" title="Только для совершеннолетних пользователей 18+">18+</span>
            <span className="footer-copy">© 2026 CaseMania. All Rights Reserved.</span>
          </div>

          <nav className="footer-nav-links" aria-label="Юридическая информация">
            <Link to="/privacy">Политика конфиденциальности</Link>
            <Link to="/terms">Пользовательское соглашение</Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}
